<template>
<div class="chapter">
<div class="inner_page">
<div class="title">
<br/><br/><br/><br/><br/><br/>
<p class="center"><img alt="" src="OEBPS/images/line.jpg"/></p>
<p class="htitle">T<span class="small1">HE</span> C<span class="small1">OMANCHE</span> E<span class="small1">MPIRE</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?baee811e